import { Card, Table } from "antd"
import { getProjectUrl } from "../datacenterModel"
import { projectTypeName } from "../../../common/constants"
import { ManHoursReportData } from "./manHoursReportApi"
import ExportCsvButton from "../ExportCsvButton"
import useDashboardReporting from "../../../hooks/useDashboardReporting"
import { CsvDateRange } from "../reportCsvExport"
import { manHoursExportColumns } from "./manHoursReportExport"
type Props = {
  report: ManHoursReportData
  dateRange: CsvDateRange
}

const ManHoursReportList = ({ report, dateRange }: Props) => {
  const dashboardReporting = useDashboardReporting()
 
  return <Card
    extra={dashboardReporting && <ExportCsvButton reportName='Labor Metrics' dateRange={dateRange} columns={manHoursExportColumns} rows={report.projects} />}
    title={
      <span style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>Work Areas {report.projects.length > 0 ? `(${report.projects.length})` : '(0)'}</span>
      </span>
    }
  >
    <Table
      dataSource={report.projects}
      rowKey={(record) => record.projectWorkareaId}
      pagination={{ showSizeChanger: true }}
      columns={[
        {
          title: 'Job Name',
          dataIndex: 'jobName',
        },
        {
          title: 'Work Area',
          dataIndex: 'projectWorkareaName',
        },
        {
          title: 'Job Type',
          dataIndex: 'jobType',
          render: (_, record) => projectTypeName(record.jobType)
        },
        {
          title: 'Customer',
          dataIndex: 'displayName',
        },
        {
          title: 'Address',
          render: (_, record) => `${record.address1} ${record.city}, ${record.state} ${record.zip}`
        },
        {
          title: 'Sales Person',
          dataIndex: 'salesPersonName',
        },
        {
          title: 'Division',
          render: (_, record) => record.divisionName
        },
        {
          title: 'Estimated Man Hours',
          dataIndex: 'estimatedManHours',
        },
        {
          title: 'Actual Man Hours',
          dataIndex: 'actualManHours',
        }
      ]}
      onRow={(record) => {
        const jobUrl = getProjectUrl(record.projectId, record.jobType, record.isSold, record.jobName)

        return {
          onClick: () => window.open(`#!/${jobUrl}`, '_blank'),
          style: { cursor: 'pointer' }
        }
      }}
    />
  </Card>
}

export default ManHoursReportList 